export default "/assets/website/images/user.svg?050a91752ea7ef38f9de24bf7362a775";